module.exports = __webpack_public_path__ + "static/media/news-cdphp-optimism.912c8160.jpg";